var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterSearchOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Selected=False, Name=Search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 6C52.5685 6 66 19.4315 66 36C66 43.2611 63.4204 49.9196 59.1276 55.1093L65.1213 60.8787C66.2929 62.0502 66.2929 63.9498 65.1213 65.1213C64.0399 66.2028 62.3382 66.286 61.1613 65.3709L60.8787 65.1213L54.8607 59.3309C49.7079 63.5017 43.1457 66 36 66C19.4315 66 6 52.5685 6 36C6 19.4315 19.4315 6 36 6ZM36 12C22.7452 12 12 22.7452 12 36C12 49.2548 22.7452 60 36 60C49.2548 60 60 49.2548 60 36C60 22.7452 49.2548 12 36 12ZM44.3095 43.9147C45.367 42.6392 45.1902 40.748 43.9147 39.6905C42.6392 38.633 40.748 38.8098 39.6905 40.0853C37.579 42.6322 34.4208 42.6387 32.3029 40.102L32.0438 39.8281C30.9537 38.8112 29.2514 38.7415 28.0774 39.7217C26.8055 40.7835 26.6352 42.6754 27.6971 43.9472C32.2194 49.3641 39.8046 49.3485 44.3095 43.9147Z",
    fill: "#9B9DA0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterSearchOff);
export default __webpack_public_path__ + "static/media/footer-search-off.87ca82a34e51e4a9647720b3af6d8810.svg";
export { ForwardRef as ReactComponent };